import styled from "styled-components";

const StyledCategoriesFilter = styled.div`
	.sb-categories-filter {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;

		&__category {
			border-radius: 100px;
			background-color: ${({ theme }) => theme.colors.iron};
			padding: 8px 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			transition-duration: 500ms;
			transition-property: all;
			max-width: 40vw;
			height: 24px;
			p {
				max-width: 40vw;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-size: 12px;
			}

			&--active {
				border: 1px solid ${({ theme }) => theme.colors.coral};
				background-color: var(--background-color);
				p {
					color: ${({ theme }) => theme.colors.coral};
				}
			}

			&:hover {
				box-shadow: 0 1px 2px -2px rgb(0 0 0 / 16%), 0 3px 6px 0 rgb(0 0 0 / 12%), 0 5px 12px 4px rgb(0 0 0 / 9%);
			}
		}
	}
`;

export default StyledCategoriesFilter;
